import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'

Vue.use(VueRouter)

const routes = [
  {
    name: 'Index',
    path: '/',
    redirect: to => {
      return {name: 'Top', params: {lang: navigator.language.substring(0, 2)}}
    }
  },
  {
    path: '/:lang',
    component: () => import('@/views/Index'),
    children: [
      // TOP画面
      {
        name: 'Top',
        path: '/',
        component: () => import('@/views/Top')
      },

      // お問い合わせ
      {
        path: 'Contact',
        component: () => import('@/views/Contact/ContactIndex'),
        children: [
          // お問い合わせフォーム
          {
            name: 'Contact',
            path: '/',
            component: () => import('@/views/Contact/Contact')
          },
          // お問い合わせ完了
          {
            name: 'ContactComplete',
            path: 'Complete',
            component: () => import('@/views/Contact/ContactComplete'),
            props: true
          }
        ]
      },

      // 地図
      {
        path: 'Map',
        component: () => import('@/views/Map/Map'),
        children: [
          {
            name: 'MapShopList',
            path: 'ShopList',
            component: () => import('@/views/Map/MapShopList'),
            meta: {footer: false}
          }
        ]
      },

      // 店舗情報
      {
        name: 'ShopDetail',
        path: 'Shop/Detail/:id',
        component: () => import('@/views/Shop/ShopDetail')
      },

      // ログイン
      {
        path: 'Login',
        component: () => import('@/views/Login/LoginIndex'),
        children: [
          // ログイン
          {
            name: 'Login',
            path: '/',
            component: () => import('@/views/Login/Login')
          },
          // パスワード再登録の申込
          {
            name: 'PassForget',
            path: 'Forget',
            component: () => import('@/views/Login/PassForget')
          },
          // パスワード再登録
          {
            name: 'PassReset',
            path: 'Reset/:hash',
            component: () => import('@/views/Login/PassReset')
          }
        ]
      },

      // 新規登録
      {
        path: 'Entry',
        component: () => import('@/views/Entry/EntryIndex'),
        children: [
          // 新規登録
          {
            name: 'EntryFirst',
            path: 'First/:kind',
            component: () => import('@/views/Entry/EntryFirst')
          },
          // ユーザー情報
          {
            name: 'UserEntry',
            path: 'User/:hash',
            component: () => import('@/views/Entry/UserEntry')
          },
          // 店舗登録
          {
            name: 'ShopEntry',
            path: 'Shop/:hash',
            component: () => import('@/views/Entry/ShopEntry')
          },
          // 登録完了
          {
            name: 'EntryComplete',
            path: 'Complete/:kind',
            component: () => import('@/views/Entry/EntryComplete'),
            props: true
          }
        ]
      },

      // マイページ
      {
        path: 'MyPage',
        component: () => import('@/views/MyPage/MyPageIndex'),
        children: [
          // ユーザー情報
          {
            name: 'MyPageUser',
            path: 'User',
            component: () => import('@/views/MyPage/UserEdit')
          },
          // 予約状況一覧
          {
            name: 'MyPageReserveList',
            path: 'Reserve/List',
            component: () => import('@/views/MyPage/ReserveList')
          },
          // 予約履歴一覧
          {
            name: 'MyPageReserveHistory',
            path: 'Reserve/History',
            component: () => import('@/views/MyPage/ReserveHistory')
          },
          // 予約内容
          {
            name: 'MyPageReserveDetail',
            path: 'Reserve/Detail/:id',
            component: () => import('@/views/MyPage/ReserveDetail')
          },
          // 予約キャンセル
          {
            name: 'MyPageCancelComplete',
            path: 'Reserve/CancelComplete',
            component: () => import('@/views/MyPage/CancelComplete')
          }
        ],
        meta: { requiresAuthKind: 0 }
      },

      // 予約
      {
        path: 'Reserve',
        component: () => import('@/views/Reserve/ReserveIndex'),
        children: [
          // 予約
          {
            name: 'Reserve',
            path: 'Shop:id',
            component: () => import('@/views/Reserve/Reserve'),
            props: true
          },
          // 予約確認
          {
            name: 'ReserveConfirm',
            path: 'Confirm',
            component: () => import('@/views/Reserve/ReserveConfirm'),
            props: true,
            meta: { requiresAuthKind: 0 }
          },
          // 予約完了
          {
            name: 'ReserveComplete',
            path: 'Complete',
            component: () => import('@/views/Reserve/ReserveComplete'),
            props: true,
            meta: { requiresAuthKind: 0 }
          }
        ]
      },

      // 店舗
      {
        path: 'Shop',
        component: () => import('@/views/Shop/ShopIndex'),
        children: [
          // 店舗メニュー
          {
            name: 'Shop',
            path: '/',
            component: () => import('@/views/Shop/Shop'),
            meta: {
              footer: false
            }
          },
          // チェックイン
          {
            name: 'ShopCheckIn',
            path: 'CheckIn',
            component: () => import('@/views/Shop/CheckIn'),
            meta: {
              footer: false
            }
          },
          // チェックアウト
          {
            name: 'ShopCheckOut',
            path: 'CheckOut',
            component: () => import('@/views/Shop/CheckOut'),
            meta: {
              footer: false
            }
          },
          // 店舗情報
          {
            name: 'ShopEdit',
            path: 'Edit',
            component: () => import('@/views/Shop/ShopEdit')
          },
          // 店舗休日登録
          {
            name: 'ShopHoliday',
            path: 'Holiday',
            component: () => import('@/views/Shop/ShopHoliday')
          },
          // 店舗画像登録
          {
            name: 'ShopImage',
            path: 'Image',
            component: () => import('@/views/Shop/ShopImage')
          },
          // 店舗レシピ一覧
          {
            name: 'ShopRecipeList',
            path: 'RecipeList',
            component: () => import('@/views/Shop/ShopRecipeList')
          },
          // 店舗レシピ登録
          {
            name: 'ShopRecipe',
            path: 'Recipe/:id',
            component: () => import('@/views/Shop/ShopRecipe')
          },
          // 編集完了
          {
            name: 'ShopComplete',
            path: 'Complete',
            component: () => import('@/views/Shop/ShopComplete')
          }
        ],
        meta: {
          requiresAuthKind: 1
        }
      },

      // レシピ
      {
        name: 'Recipe',
        path: 'Recipe',
        component: () => import('@/views/Recipe/Recipe')
      }
    ]
  }
]

/**
 * スクロール制御
 */
const scrollBehavior = (to, from, savedPosition) => {
  if (savedPosition) {
    return savedPosition
  } else {
    return { x: 0, y: 0 }
  }
}

/**
 * VueRouter初期化
 */
const router = new VueRouter({
  mode: 'history',
  base: process.env.VUE_APP_PUBLIC_PATH,
  routes,
  scrollBehavior
})

/**
 * ページ遷移前
 */
router.beforeEach((to, from, next) => {
  // 404 file not found
  if (to.name === null || ['en', 'ja', 'cn'].indexOf(to.params.lang) < 0) {
    if (process.env.NODE_ENV === 'production') {
      window.location = '/err/404.html'
      return
    }
  }

  // Auth
  const matchedKind = to.matched.filter(record => record.meta.requiresAuthKind !== undefined)
  if (matchedKind.length > 0) {
    const isRedirect = !store.getters.login_isLogin || matchedKind.some(record => record.meta.requiresAuthKind !== store.getters.login_kind)
    if (isRedirect) {
      next({name: 'Login', params: to.params, query: {next: to.name}})
      return
    }
  }

  // cool url !!
  if (to.name === 'Top' && to.path.lastIndexOf('/') !== to.path.length - 1) {
    next({path: `${to.path}/`})
    return
  }

  // Next
  next()
})

export default router
